import { App } from 'vue';
import { DIALOG_ROOT_ID } from './constants';
import { DialogClass } from './VueDialog';

type TConfigurationCallback = (app: App<Element>) => void;

class ModalAlertPlugin {
  private initContainer(): void {
    const container = document.createElement('div');

    container.id = DIALOG_ROOT_ID;
    document.body.appendChild(container);
  }

  install(app: App<Element>, configurationCb?: TConfigurationCallback): void {
    this.initContainer();

    if (configurationCb) {
      DialogClass.setAppConfiguratorCallback(configurationCb);
    }
  }
}

export default new ModalAlertPlugin();
